const config = require('../config');
const apiConfig = require('../api-config');
const apiFactory = require('../resources/alerts/api-factory');
const serviceFactory = require('../resources/alerts/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/userprofile/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}]';

  return app => app
    .match((`${p}.alerts.list[{keys:inputParam}][{keys:guidStr}]`), requests =>
      Promise.all(requests.map(({ req, res }) =>
           service.getUserAlerts( req.params.inputParam ,req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
    .match((`${p}alerts.seenStatus[{keys:inputParam}][{keys:guidStr}]`), requests => {
      return Promise.all(requests.map(({ req, res }) =>
        service.sendUserAlertSeenStatus(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      ))
    }
    )
     .match(`${p}banner.getDowntime[{keys:inputParam}][{keys:guidStr}]`, requests => 
      Promise.all(
        requests.map(({ req, res }) => 
          service.getDowntime(req.params.inputParam)
            .then(response => res.value(response))
            .catch(res.error)
      )));
}

module.exports = addRoutes;